export interface IAppMessage {
    before?: {
        msg: string,
        sub: string
    },
    after?: {
        msg: string,
        sub: string
    }
}

export interface IAppMessageGroup {
    [key: string]: IAppMessage
}

export interface IAppSimpleMessageGroup {
    [key: string]: string
}

export enum ETutorialEntries {
    about = 0,
    signupTerms = 1,
    signupTutorial = 2,
    accountTutorial = 3,
    storyTutorial = 4,
    gmapTutorial = 5,
    inventoryTutorial = 6,
    AR = 8,
    placesTutorial = 9,
    chatTutorial = 10,
    placeAdsTutorial = 11,
    groupMemberTutorial = 12,
    groupAdminTutorial = 13,
    storylineTutorial = 14,
    storiesTutorial = 15,
    extras = 16,
    events = 17,
    eventHome = 18,
    eventJoin = 19,
    rating = 20,
    warning = 21,
    liveChat = 22,
    adConsent = 23,

    myPlaceQR = 24,
    myPlaceDetails = 25,
    myPlaceRegister = 26,
    marketplace = 27,

    prominentDisclosure = 28,
    prominentDisclosureTown = 29,

    warningTown = 32,
    subscriptionsTown = 33,
    editorTemplate = 34,
    editorMode = 35,
    storyCreatorMode = 36,
    storylineCreatorMode = 37,

    editControls = 38,
    reviewControls = 39,
    productionControl = 40,

    ttsChallenge = 301,
    ttsMeetingPlace = 302,
    ttsStory = 303,
    ttsTreasureFound = 304,
    ttsTreasureUnlocked = 305,
    ttsInventory = 306,


    localTtsBackgroundMode = -100,

    activateStoryTutorialEn = 51,
    storylineTutorialVideo = 52,

    reviewContact = 58,
    howItWorks = 59,
    checkoutNote = 60,
    appNotes = 61,
    testFlightNotes = 62,
    webNotes = 63,
    checkoutNotes = 64,
    unlockNotes = 65,
    findStoryNotes = 66,
    bookingCodeNote = 70,
    mapPreview = 71,
    appStoreNotes = 72,
    playStoreNotes = 73,
    connectHeader = 74,
    connectNotes = 75
};

export class Messages {
    public static notification = {
        backgroundMode: {
            after: {
                msg: "LP Connect",
                sub: "Running in background mode"
            }
        }
    };

    /**
     * text content request codes
     * 0xx tutorials
     * 1xx activities
     */
    public static codes = {
        about: 0,
        signupTerms: 1,
        signupTutorial: 2,
        accountTutorial: 3,
        storyTutorial: 4,
        gmapTutorial: 5,
        inventoryTutorial: 6,
        AR: 8,
        placesTutorial: 9,
        chatTutorial: 10,
        placeAdsTutorial: 11,
        groupMemberTutorial: 12,
        groupAdminTutorial: 13,
        storylineTutorial: 14,
        storiesTutorial: 15,
        extras: 16,
        events: 17,
        eventHome: 18,
        eventJoin: 19,
        rating: 20,
        warning: 21,
        liveChat: 22,
        adConsent: 23,

        myPlaceQR: 24,
        myPlaceDetails: 25,
        myPlaceRegister: 26,
        marketplace: 27,

        prominentDisclosure: 28,
        prominentDisclosureTown: 29,

        warningTown: 32,
        subscriptionsTown: 33,
        editorTemplate: 34,
        editorMode: 35,
        storyCreatorMode: 36,
        storylineCreatorMode: 37,

        editControls: 38,
        reviewControls: 39,
        publishControls: 40,

        ttsChallenge: 301,
        ttsMeetingPlace: 302,
        ttsStory: 303,
        ttsTreasureFound: 304,
        ttsTreasureUnlocked: 305,
        ttsInventory: 306,


        localTtsBackgroundMode: -100
    };

    public static toast = {
        proceedToTheNextLocation: "Go to the place shown on the map",
        beAware: "Remember to be aware of your surroundings",

        compassNotAvailable: "NAV: Device compass not available. Orientation is limited to GPS updates.",

        waitingForGPS: "Waiting for GPS",
        waitingForLocation: "Waiting for location",
        GPSNotAvailable: "GPS signal not available",
        GPSNotFound: "GPS signal not found",
        GPSSlowUpdate: "GPS seems slow",
        checkLocationServices: "Check location services",
        GPSUnresponsive: "GPS seems unresponsive",
        compassNeedsCalibration: "Compass needs calibration",

        errorLoadingStory: "Error loading story data",
        errorPreloadingStory: "Error preloading story data",
        errorLoadingInventory: "Error loading inventory data",
        errorLoadingResources: "Error loading resources",
        disconnectedFromNetwork: "Disconnected from network",

        loadingDirections: "Loading directions..",

        login: "Login",
        loadingResources: "Loading resources",
        checking: "Checking..",
        redirectingToCheckout: "Redirecting to checkout..",
        waitingForRefresh: "Waiting for refresh..",
        loadingProducts: "Loading products..",
        registering: "Registering..",
        waitingForStore: "Waiting for store..",
        openingConnect: "Opening Connect..",
        loading: "Loading..",
        pleaseWait: "Please wait..",
        loadingSavedPlace: "Loading saved place..",
        loadingPlace: "Loading place",
        loadingNewPlaces: "Loading new places",
        loadingNewDestination: "Loading new destination..",
        retryLoading: "Retry loading..",
        updatingLocation: "Updating location..",
        placingDestination: "Placing destination..",
        returningToWorldMap: "Returning to world map..",
        scanningNearbyPlaces: "Scanning nearby places..",
        loadingStoryLocations: "Loading story locations..",
        loadingStoryProgress: "Loading story progress..",
        initializingMap: "Initializing map",
        savingProgress: "Saving progress",
        checkingForUpdates: "Checking for updates",
        uploading: "Uploading..",
        initializing: "Initializing..",
        verifying: "Verifying..",
        connecting: "Connecting..",
        loadingTranslation: "Loading translation..",
        joiningTeam: "Joining team..",
        loadingTeamProgress: "Loading team progress..",
        searchingForMeetingPlace: "Searching for meeting place..",
        transferringToMeetingPlace: "Transferring to meeting place..",
        waitingForNetworkConnection: "Waiting for network connection..",
        processing: "Processing..",

        question: "Question",
        checkAnswer: "Check",
        clue: "Clue",
        continue: "Continue",


        availableOptions: "<p>Available options: </p>",
        availaleCheckoutLP: "<p>>Checkout with LP coins</p>",
        availableCheckoutStripeConnect: "<p>>Checkout with Stripe or LP Connect</p>",
        availableCheckoutIAP: "<p>>Checkout with in-app purchase (unavailable in TestFlight)</p>",
        availableCheckoutIAPDist: "<p>>Checkout with in-app purchase</p>",
        availableCheckoutRedeem: "<p>>Unlock with redeem code</p>",
        availableScanUnlock: "<p>>Scan QR / enter unlock code</p>",
        availableUnlock: "<p>>Unlock</p>",

        scanQR: "Scan QR",
        unlock: "Unlock",


        locked: "<p>LOCKED</p>",
        youNeedAmountLP: "<p>You need # LP to unlock this story</p>",
        discountAvailable: "<p>Discounted paid options available</p>",
        paidOptionsAvailable: "<p>Paid options available</p>",
        useUnlockCode: "<p>You have to use the unlock code indicated by the provider to access this story</p>",
        useRedeemCode: "<p>You may use the redeem code indicated by the provider to unlock this story</p>",

        validated: "Validated",
        skipScan: "Skip scan nearby places",
        teamProgress: "Team progress",

        storyCompleted: "<p>Story completed!</p>",
        returnToStoryline: "<p>Return to storyline..</p>",

        collected: "Collected",
        collectedItem: "Collected item",

        findStory: "Find story",
        findYourBooking: "Find your booking",
        bookingReferenceInput: "booking reference number",
        bookingReferenceAction: "<use booking reference>",
        findBookingNotes: "<p>Examples:</p><p>Standard unlock code: ######</p><p>Viator/Tripadvisor: VIA-########</p><p>GetYourGuide: GYG#########</p>",

        forgotAppBackground: "Did you forget the app in background?",
        appClosingInMinutes: "App closing in # minutes",
        appClosingSoon: "App closing soon",

        redeemCode: "Redeem code",
        standardCode: "Unlock code",
        bookingReference: "Booking reference",
        redeemBookingTicket: "Redeem your booking ticket",
        checkout: "Checkout"
    };


    public static tts = {
        // typos may be there for correct pronounciation
        destinationReached: "Please proceed to the next location. Once you get there, you will have to complete a challenge. Please be aware of your surroundings. You may keep the phone in your pocket while doing outdoor activities.",
        welcomeToWorldMap: "Welcome to world map! Please wait for the content to load.",
        welcomeToWorldMapStoryMode: "Welcome to world map! The story will start now. Please wait for the content to load.",
        errorLoadingResources: "There was an error loading some resources. Please check your connection.",
        networkDisconnected: "Network disconnected. Please check your connection.",
        GPSNotAvailable: "G.P.S. signal is not available. Please check your location settings and be aware that it may take a while to acquire location.",
        searchZoneReached: "Search zone, reached!",
        checkpointReached: "Checkpoint reached!",
        achievementsUnlocked: "You have unlocked new achievements.",
        challengeComplete: "Challenge complete! Check the world map to continue.",
        challengeFailed: "Challenge failed! Check the world map to continue.",
        verifiedPlaces: "There are verified places nearby that might offer special discounts.",
        bgModeDefault: "The app is running in background mode.",
        bgModeFirst: "The app is running in background mode. Please allow background location always if requested, and be aware that the app is still using battery."
    };

    public static msg = {
        success: {
            after: {
                msg: "Success",
                sub: ""
            }
        },
        joinedEvent: {
            after: {
                msg: "Joined",
                sub: "Let the treasure hunting begin"
            }
        },
        codePushUpdated: {
            after: {
                msg: "App updated",
                sub: "Push update installed"
            }
        },
        wannabetester: {
            after: {
                msg: "Test account",
                sub: "Use tester mode?"
            }
        },
        authenticationError: {
            after: {
                msg: "Authentication error",
                sub: ""
            }
        },
        authenticationPreloadError: {
            after: {
                msg: "Preload error",
                sub: ""
            }
        },
        emailUpdated: {
            after: {
                msg: "Email updated",
                sub: "Please check your inbox for validation"
            }
        },
        registerPaymentSave: {
            after: {
                msg: "Request validated",
                sub: "Automatic billing is enabled. Your payment invoice will be delivered by email at the end of the billing cycle"
            }
        },
        registerPaymentNoSave: {
            after: {
                msg: "Request validated",
                sub: "Your payment invoice will be delivered by email"
            }
        },
        registerCreditCard: {
            after: {
                msg: "Billing",
                sub: "Confirm secure checkout"
            }
        },
        registerCreditCardAutomaticBilling: {
            after: {
                msg: "Billing",
                sub: "Confirm secure checkout with automatic billing"
            }
        },
        cancelBilling: {
            before: {
                msg: "Cancel billing",
                sub: "This will remove your payment method from the secure vault"
            },
            after: {
                msg: "Success",
                sub: "Your payment method has been removed from the secure vault"
            }
        },

        cancelSubscription: {
            before: {
                msg: "Cancel subscription",
                sub: "<p>The subscription will be disabled at the end of the current billing cycle</p>"
            },
            after: {
                msg: "Success",
                sub: "<p>Your subscription has been cancelled and will be disabled at the end of the current billing cycle</p><p>You may restart your subscription at any time</p>"
            }
        },

        unauthorizedAccess: {
            after: {
                msg: "Unavailable",
                sub: "This section requires authentication"
            }
        },

        cancelPackage: {
            before: {
                msg: "Cancel package",
                sub: "<p>The package and associated benefits will be disabled at once, with no refund options</p><p>Should you require a refund, please contact us via email instead</p>"
            },
            after: {
                msg: "Success",
                sub: "<p>The selected package has been removed from your account</p>"
            }
        },

        featureLockedAtTheMoment: {
            after: {
                msg: "Locked",
                sub: "This feature is not available at the moment"
            }
        },
        requestFailedTryAgain: {
            after: {
                msg: "Request failed",
                sub: "Please try again later"
            }
        },
        removeGroupMember: {
            before: {
                msg: "Remove member",
                sub: "This will remove the member from the group"
            }
        },
        loadIapDetails: {
            before: {
                msg: "Store products",
                sub: "Load and display store product details?"
            }
        },
        storeTimeout: {
            after: {
                msg: "Store Timeout",
                sub: "Some items failed to load from the store and might not display properly"
            }
        },
        removePhoto: {
            before: {
                msg: "Remove photo",
                sub: ""
            },
            after: {
                msg: "Info",
                sub: "Photo removed"
            }
        },
        photoNotAvailableGen: {
            after: {
                msg: "Info",
                sub: "Photo not available"
            }
        },
        photoNotAvailable: {
            after: {
                msg: "Info",
                sub: "You don't have a profile photo at the moment"
            }
        },
        platformNotSupported: {
            after: {
                msg: "Unknown platform",
                sub: "<p>Your device is not supported.</p><p>The app might not work as expected.</p>"
            }
        },
        iPadDetected: {
            after: {
                msg: "Platform",
                sub: "<p>It seems you are using an iPad.</p><p>Please be aware that the app is optimized for iPhones.</p>"
            }
        },
        exit: {
            before: {
                msg: "Exit app",
                sub: ""
            },
        },
        joinOrSelectGroup: {
            before: {
                msg: "Lobby",
                sub: "Join new group or select from your list"
            },
        },
        worldMapUpdated: {
            after: {
                msg: "Success",
                sub: "World Edit registered"
            }
        },
        info: {
            after: {
                msg: "Info",
                sub: ""
            }
        },
        gpsNotAvailableRestartDevice: {
            after: {
                msg: "Location",
                sub: "<p>GPS location could not be acquired</p><p>Please restart your device and try again</p><p>Keep in mind that GPS location is usually not available indoors</p>"
            }
        },
        passwordChanged: {
            after: {
                msg: "Info",
                sub: "Password changed"
            }
        },
        accountValidated: {
            after: {
                msg: "Info",
                sub: "Account validated"
            }
        },
        referralCodeValidated: {
            after: {
                msg: "R-Code",
                sub: ""
            }
        },
        featureUnlocked: {
            after: {
                msg: "Unlocked",
                sub: "Feature available in the game"
            }
        },
        featureLocked: {
            after: {
                msg: "Locked",
                sub: "Proceed to unlock"
            }
        },
        featureLockedTemp: {
            after: {
                msg: "Locked",
                sub: "<p>Not available in this context</p>Check location, app version, release date</p>"
            }
        },
        referralCodeUsed: {
            after: {
                msg: "R-Code",
                sub: "<p>Thanks for using the R-Code to register</p><p>Your friend will receive a bonus</p>"
            }
        },
        requiresRestartBgMode: {
            after: {
                msg: "Restart required",
                sub: "<p>To ensure that the background mode works properly this change requires restarting the app.</p><p>Please restart the app or reset to the previous setting.</p>"
            }
        },
        usernameChanged: {
            after: {
                msg: "Info",
                sub: "Username changed"
            }
        },
        submitWithoutReview: {
            after: {
                msg: "Review",
                sub: "Submit without review"
            }
        },
        accountDeleted: {
            after: {
                msg: "Info",
                sub: "Acount deleted"
            }
        },
        newInbox: {
            after: {
                msg: "Newsfeed",
                sub: "<p>You have new messages in the Newsfeed</p>"
            }
        },
        mpSelectChallengeLeader: {
            after: {
                msg: "MP",
                sub: "<p>Pick a challenge on the map to start a game</p>"
            }
        },
        cannotAcquireLocation: {
            after: {
                msg: "Location",
                sub: "<p>Could not acquire location</p><p>Please check your location services and open the map again to retry</p>"
            }
        },
        coinsPurchased: {
            after: {
                msg: "Account updated",
                sub: "LP has been added to your account"
            }
        },
        feedbackReceived: {
            after: {
                msg: "Thank you",
                sub: "Your feedback has been registered"
            }
        },
        photoUploaded: {
            after: {
                msg: "Info",
                sub: "Photo uploaded"
            }
        },
        photoUploadSource: {
            before: {
                msg: "Upload photo",
                sub: "Select source"
            }
        },
        addProfilePhoto: {
            after: {
                msg: "Profile photo",
                sub: "Do you want to add a profile photo now?"
            }
        },
        addProfilePhotoExt: {
            after: {
                msg: "Profile photo",
                sub: "Do you want to use your existing signup photo?"
            }
        },
        addPhotoTreasure: {
            before: {
                msg: "Content creator",
                sub: "Upload photo"
            }
        },
        photoDeleted: {
            after: {
                msg: "Info",
                sub: "Photo deleted"
            }
        },
        passwordsDoNotMatch: {
            after: {
                msg: "Request failed",
                sub: "Passwords do not match"
            }
        },
        logOut: {
            before: {
                msg: "Log out",
                sub: "This will clear your local data"
            }
        },
        deleteGroup: {
            before: {
                msg: "Delete group",
                sub: "Please confirm"
            }
        },
        leaveGroup: {
            before: {
                msg: "Leave group",
                sub: "Please confirm"
            }
        },
        accountNotValidated: {
            after: {
                msg: "Account",
                sub: "Please validate your email account"
            },
        },
        termsNotAgreed: {
            after: {
                msg: "Account",
                sub: "You may delete your account if for some reason you don't find the Terms and Conditions acceptable"
            },
        },
        serviceNotAvailable: {
            after: {
                msg: "Not available",
                sub: "This service is not available at the moment"
            },
        },
        exitMap: {
            before: {
                msg: "Exit map",
                sub: ""
            }
        },
        settingsUpdated: {
            after: {
                msg: "Info",
                sub: "Settings updated"
            }
        },
        registerClient: {
            after: {
                msg: "Request validated",
                sub: "Continue"
            }
        },
        subscribeToPrivateStory: {
            after: {
                msg: "Request validated",
                sub: "Subscribed"
            }
        },
        bookingReferenceMissing: {
            after: {
                msg: "Check booking",
                sub: "Please enter the booking reference first"
            }
        },
        formRequiredFields: {
            after: {
                msg: "Form",
                sub: "Please fill in the required fields"
            }
        },
        invalidFormData: {
            after: {
                msg: "Invalid format",
                sub: "Please check the required format"
            }
        },
        registerClientError: {
            after: {
                msg: "Request failed",
                sub: "Invalid code"
            }
        },
        subscriptionCreated: {
            after: {
                msg: "Checkout",
                sub: "Subscription created"
            }
        },
        paymentRegistered: {
            after: {
                msg: "Checkout",
                sub: "Payment registered"
            }
        },
        removeContentCard: {
            before: {
                msg: "Remove item",
                sub: "Remove selected item from the list"
            }
        },
        removeCard: {
            before: {
                msg: "Remove payment method",
                sub: "Remove selected payment method"
            },
            after: {
                msg: "Remove payment method",
                sub: "Payment method removed"
            }
        },
        confirmCheckoutSubscription: {
            before: {
                msg: "Checkout",
                sub: "Confirm subscription"
            },
            after: {
                msg: "Checkout",
                sub: "Subscription confirmed"
            }
        },
        confirmCheckoutProduct: {
            before: {
                msg: "Checkout",
                sub: "Confirm payment"
            },
            after: {
                msg: "Checkout",
                sub: "Payment confirmed"
            }
        },
        signup: {
            after: {
                msg: "Account registered",
                sub: "Please log in"
            }
        },
        requestNewValidationEmail: {
            after: {
                msg: "Email sent",
                sub: "Please validate your email account"
            }
        },
        requestNewPasswordEmail: {
            after: {
                msg: "Email sent",
                sub: "Check your email for temporary password"
            }
        },
        thanksForRating: {
            after: {
                msg: "Thank you",
                sub: "You make stories unique"
            }
        },
        removePrivateStory: {
            before: {
                msg: "Unsubscribe",
                sub: "Remove private story"
            }
        },
        serverError: {
            after: {
                msg: "Request failed",
                sub: "Not available"
            }
        },
        sessionExpired: {
            after: {
                msg: "Session expired",
                sub: "Please log in again"
            }
        },
        preCheckoutError: {
            after: {
                msg: "Checkout error",
                sub: "There was an error processing your request"
            }
        },
        notingToUpdate: {
            after: {
                msg: "Unchanged",
                sub: "Nothing to update"
            }
        },
        googlePlaceNotFound: {
            after: {
                msg: "Resource unavailable",
                sub: "Google place not found"
            }
        },
        shareLocationTeam: {
            before: {
                msg: "Location updates",
                sub: "<p>Do you want to share your location with your team members?</p><p>This feature is in beta and might not work as expected</p><p>Game experience should not be affected either way</p>"
            }
        },
        loginFailed: {
            after: {
                msg: "Authentication error",
                sub: "Could not log in to your account"
            }
        },
        loginAgain: {
            after: {
                msg: "Login",
                sub: "Log in with your (existing) account"
            }
        },
        mpError: {
            after: {
                msg: "MP Exception",
                sub: "Check your connection"
            }
        },
        mpChallengeLoadError: {
            after: {
                msg: "MP Exception",
                sub: "Requested challenge could not be loaded"
            }
        },
        treasureScannerLoadError: {
            after: {
                msg: "Request failed",
                sub: "Treasure Scanner is not available at the moment"
            }
        },
        itemNotAvailable: {
            after: {
                msg: "Out of stock",
                sub: "Collect or buy more items"
            }
        },        
        storyNotAvailable: {
            after: {
                msg: "Request failed",
                sub: "This story is not available at the moment"
            }
        },       
        clearProgress: {
            before: {
                msg: "Replay story",
                sub: "Reset progress and keep saved places"
            }
        },       
        orderCancelled: {
            after: {
                msg: "Store",
                sub: "Order cancelled"
            }
        },
        error: {
            after: {
                msg: "Error",
                sub: ""
            }
        },
        localError: {
            after: {
                msg: "Local exception",
                sub: "Unexpected content error"
            }
        },
        networkErrorRetry: {
            after: {
                msg: "Network error",
                sub: "<p>Check your network connection and try again to continue.</p>"
            }
        },
        applicationError: {
            after: {
                msg: "Unexpected error",
                sub: "<p>An unexpected error occured in the application</p><p>Please report the issue with the integrated support service</p><p>Then, please restart the app to continue</p>"
            }
        },       
        mpConnectChatError: {
            after: {
                msg: "Connection error",
                sub: "Please close and open the page again"
            }
        },       
        alreadyRegistered: {
            before: {
                msg: "Action unavailable",
                sub: "You are already registered"
            }
        },
        alreadyCheckedOut: {
            before: {
                msg: "Warning",
                sub: "<p>You have already completed checkout.</p><p>Your unlock code is shown below.</p><p>You may proceed to purchase another access code if you need.</p>"
            }
        },
        requestFailed: {
            after: {
                msg: "Request failed",
                sub: "Not available"
            }
        },
        qrCodeNotRegistered: {
            after: {
                msg: "Unavailable",
                sub: "QR Code not enabled"
            }
        },
        resourceUnavailable: {
            after: {
                msg: "Resource unavailable",
                sub: "Check data connection."
            }
        },
        usernameUndefined: {
            after: {
                msg: "Undefined username",
                sub: "Please set a username"
            }
        },        
        layersNotInitialized: {
            after: {
                msg: "GMAP",
                sub: "Network error: layers not initialized"
            }
        },
        batteryCheckFailed: {
            after: {
                msg: "Request failed",
                sub: "<p>Could not sync drone battery level</p><p>Check your internet connection</p>"
            }
        },
        groupNotSelected: {
            after: {
                msg: "Request failed",
                sub: "Select a team first"
            }
        },
        roleNotSelected: {
            after: {
                msg: "Request failed",
                sub: "Select a role first"
            }
        },
        resourceInitFailed: {
            after: {
                msg: "Resource unavailable",
                sub: "<p>Service not available at the moment</p><p>Check your internet connection</p>"
            }
        },
        mediaServiceNotAvailable: {
            after: {
                msg: "Request failed",
                sub: "Media service not available"
            }
        },
        mediaServiceError: {
            after: {
                msg: "Request failed",
                sub: "Media service error"
            }
        },       
        linkNotFound: {
            after: {
                msg: "Not found",
                sub: "The requested link could not be found"
            }
        },      
        pleaseReload: {
            after: {
                msg: "Please reload page",
                sub: "Some data could not be retrieved from the server"
            }
        },
        resetQRCode: {
            before: {
                msg: "Reset QR code",
                sub: "Note: The previous code will be replaced"
            },
            after: {
                msg: "Reset QR code",
                sub: "QR code has been updated"
            }
        },
        storyLocked: {
            after: {
                msg: "Locked",
                sub: "This story is locked at the moment"
            }
        },
        storyLockedCoins: {
            after: {
                msg: "Locked",
                sub: "Proceed to unlock this story with LP"
            }
        },
        reviewTerms: {
            after: {
                msg: "Info",
                sub: "Please review the terms and conditions"
            }
        },       
        warning: {
            after: {
                msg: "Warning",
                sub: ""
            }
        },
        googleError: {
            after: {
                msg: "Not found",
                sub: "Google services are temporary unavailable. Please try again later"
            }
        },
        googleQuotaExceeded: {
            after: {
                msg: "Overloaded",
                sub: "Google services are temporary unavailable. Please try again later"
            }
        },        
        browserNotSupported: {
            after: {
                msg: "Browser warning",
                sub: "<p>You are using an unsupported browser and the app might not work as expected. Please reopen the app by pasting the URL in a supported browser:</p>"
            }
        }
    };
}
